(function($) {

  'use strict';

  function MapLocation() {

    var self = this,
        $cache = {},
        translations = false,
        markerUserImg = false,
        markerImg = false,
        infoBoxIcon = false,
        markersValues = false,
        userMarker = false,
        allMarkers = [],
        map = false,
        geocoder = false;


    var mapOptions = {
          center: { lat: 45.501634, lng: -73.567663 },
          scrollwheel : false,
          zoom: 13,
          styles: [{"featureType":"all","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]}]
        };

    var infoBoxDefaultOptions = {
                disableAutoPan: false,
                maxWidth: 0,
                pixelOffset: new google.maps.Size(-200, 0),
                zIndex: null,
                boxStyle: { width: "250px" },
                closeBoxURL: "",
                infoBoxClearance: new google.maps.Size(1, 1),
                isHidden: false,
                pane: "floatPane",
                enableEventPropagation: false
            };
    /**
     * Close infobox
     */
    self.closeInfoBox = function () {
      $.each(allMarkers, function(index, markerer) { markerer.infobox.close(); });   
      removeHash();                                 
    }

    /**
     * Select Marker
     */
    function selectMarker(id) {
      $.each(allMarkers, function(index, marker) {
        if(marker.post_id === id) {
          google.maps.event.trigger( marker, 'click' );

          // Center the marker
          var markerLatLng = new google.maps.LatLng(parseFloat(marker.position.lat()), parseFloat(marker.position.lng()));
          map.setCenter(markerLatLng);
        }
      });                                 
    }

    /**
     * Zip Code Search
     */
    function zipcodeSearch(zip) {
      geocoder.geocode({'address': zip}, function (results, status) {
        
        if (status === google.maps.GeocoderStatus.OK) { //IF CODE POSTAL IS VALID
          
          var userLocation = results[0].geometry.location;
          var userLatLng = new google.maps.LatLng(parseFloat(userLocation.lat()), parseFloat(userLocation.lng()));
          
          map.setZoom(13);
    
          map.setCenter(userLatLng);
          setUserMarker(userLatLng);
    
          //Get zip code data
          // var ville = "";
          // var province = "";
          // var pays = "";
          // for (var i = 0; i < results[0].address_components.length; i++) {
          //   if (results[0].address_components[i].types[0] === "locality") {
          //     ville = results[0].address_components[i].long_name;
          //   }
          //   if (results[0].address_components[i].types[0] === "administrative_area_level_1") {
          //     province = results[0].address_components[i].long_name;
          //   }
          //   if (results[0].address_components[i].types[0] === "country") {
          //     pays = results[0].address_components[i].long_name;
          //   }
          // }
    
          // //Change your location text
          // $("#yourLocationAdresse").html(ville);
          // $("#yourLocationProvince").html(province + ", " + pays);
    
          //Calc and display KM          
          for (var i = 0; i < markersValues.length; i++) {
            var locationLat = markersValues[i].lat;
            var locationLng = markersValues[i].lng;
            var locationLatLng = new google.maps.LatLng(parseFloat(locationLat), parseFloat(locationLng));
    
            var distance = (google.maps.geometry.spherical.computeDistanceBetween(userLatLng, locationLatLng) / 1000).toFixed(1);
            
            var $boxItem = $cache.mapBoxItem.filter("#location" + markersValues[i].id);
            $boxItem.find('.location-distance-km').html(distance + " km");
            $boxItem.attr("data-distance", distance);
          }
    
          //Sort by KM
          $cache.mapBoxItem.sort(function (a, b) {
            return +a.dataset.distance - +b.dataset.distance;
          }).appendTo($cache.mapBox);
    
        }
      });                                 
    }

    /**
     * On box click handler
     */
    function onBoxClick(e) {
      var $el = $(this);
      var id = $el.data('id'); 

      selectMarker(id);                    
    }

    /**
     * On form submit
     */
    function onSubmit(e) {
      e.preventDefault();

      var val = $cache.zipInput.val();

      if(val === undefined || val === "") {

        var cookie = Cookies.get('bd_cp');
        if(cookie !== undefined || cookie !== "") {
          zipcodeSearch(cookie);
        }

      } else {
        zipcodeSearch(val);
      }

      setTimeout(function(){
        $('html, body').animate({ scrollTop : $('#map-section').offset().top }, 700);
      }, 100);
    }

    /**
     * URL handling
     */
    function changeHash(id) {
      history.replaceState(null, null, "#"+id);    
      location.hash=id;
    }

    function removeHash() {
      location.href.split('#')[0];
    }

    function checkHash() {
      var hash = window.location.hash;
      hash = hash.replace("#", "");
      var id = parseInt(hash);

      selectMarker(id);
    }

    /**
     * Get infoBox HTML
     */
    function getInfoBoxHTML(infos) {
      var html = '';

      html += '<div class="map-info-box">';
        html += '<button type="button" class="map-info-box__close js-map-info-box-close" onclick="window.mapLocationInstance.closeInfoBox()">';
          html += '<span class="sr-only">Close</span>';
        html += '</button>';
        html += '<div class="main-title__wrapper">';
          html += '<div class="icon"><img src="'+infoBoxIcon+'" width="250" height="55" class="img-fluid" alt=""></div>';
          html += '<div class="map-info-box__content">';
            html += '<h2 class="main-title">'+infos.titre+'</h2>';
            html += '<p class="map-info-box__text"><strong>'+translations.address+'</strong></p>';

            html += '<p class="map-info-box__text color-grey">'+infos.rue+', ';
            if(infos.infoSup !== "") {
              html += infos.infoSup+ ', ';
            }
            html += '<br />'+ infos.ville+', '+ infos.province+' '+ infos.codepostal +'</p>';

          html += '</div>';
        html += '</div>';
      html += '</div>';

      return html;
    }

    /**
     * Set google map markers
     */
    function setMarkers() {
      if(!map) return false;

      if(!markersValues) {
        // Stored values are set in the PHP template (pages/page-boutique.php)
        markersValues = window.stored.mapMarkers;
      }

      if(!markerImg) {
        // Stored values are set in the PHP template (pages/page-boutique.php)
        markerImg = window.stored.markerImg;
      }

      if(!infoBoxIcon) {
        // Stored values are set in the PHP template (pages/page-boutique.php)
        infoBoxIcon = window.stored.infoBoxIcon;
      }

      for(var i=0; i<markersValues.length; i++) {
        // Create marker infoBox
        var googleBoxHTML = getInfoBoxHTML(markersValues[i]);

        var infoBoxOptions = infoBoxDefaultOptions;
        infoBoxOptions.content = googleBoxHTML;

        var infoBox = new InfoBox(infoBoxOptions);

        // Create marker
        var myLatlng = new google.maps.LatLng(parseFloat(markersValues[i].lat),parseFloat(markersValues[i].lng));

        var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
                title: markersValues[i].titre,
                post_id: markersValues[i].id,
                icon: markerImg,
                rue: markersValues[i].rue,
                infoSup: markersValues[i].infoSup,
                ville : markersValues[i].ville,
                codepostal : markersValues[i].codepostal,
                infobox : infoBox
            });

        // Store Marker
        allMarkers.push(marker);

        // Bind click event handler on marker
        google.maps.event.addListener(marker, 'click', function(event) {
          $.each(allMarkers, function(index, markerer) { markerer.infobox.close(); });

          this.infobox.open(map, this);
          map.setCenter(this.getPosition());
          map.panBy(-200,50);

          changeHash(this.post_id);
        });
      }
    }

    /**
     * Set user map marker
     */
    function setUserMarker(loc) {
      if(!map) return false;

      if(!markerUserImg) {
        // Stored values are set in the PHP template (pages/page-boutique.php)
        markerUserImg = window.stored.markerUserImg;
      }

      if(userMarker) userMarker.setMap(null);
      userMarker = new google.maps.Marker({
        position: loc,
        map: map,
        icon : markerUserImg
      });
    }

    /**
     * Init user geoloc
     */
    function initGeoloc() {
      if(!map) return false;

      Cookies.remove('bd_cp');

      if (navigator.geolocation && !window.location.hash) {
        
        navigator.geolocation.getCurrentPosition(function (position) {
          var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

          geocoder.geocode({'latLng': latlng}, function (results, status) {
            
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[1]) {
                
                map.setZoom(13);
                map.setCenter(latlng);
      
                var postcode = "";
                for (var i = 0; i < results[0].address_components.length; i++) {
                  if (results[0].address_components[i].types[0] === "postal_code") {
                    postcode = results[0].address_components[i].long_name;
                  }
                }
      
                Cookies.set('bd_cp', postcode);

                zipcodeSearch(postcode);
 
              } else {
                console.log('No results found');
              }
            }
          });
        }, function(error){ 
          console.log(error);
        }, {timeout:10000});

      }
    }

    /**
     * Init google map
     */
    function initMap() {
      if(map) return false;

      if(!translations) {
        // Stored values are set in the PHP template (pages/page-boutique.php)
        translations = window.stored.mapTranslations;
      }

      // Init google map instance
      map = new google.maps.Map($cache.map[0], mapOptions);

      // Init google map geocoder instance
      if(!geocoder) geocoder = new google.maps.Geocoder();
      initGeoloc();

      // Init map content
      setMarkers();
      checkHash();
    }

    /**
     * Store dom elements
     */
    function initCache() {
      $cache.zipForm = $cache.main.find('.zipcode-form');
      $cache.zipInput = $cache.zipForm.find('.form__field');

      $cache.mapSection = $cache.main.find('.map-section');

      $cache.mapBox = $cache.mapSection.find('.map-main-box');
      $cache.mapBoxItem = $cache.mapBox.find('.map-main-box__item');
      $cache.mapBoxItemCTA = $cache.mapBoxItem.find('.js-map-box-store');

      $cache.mapWrapper = $cache.mapSection.find('.map-container');
      $cache.map = $cache.mapWrapper.find('#map');
    }

    /**
     * Register events
     */
    function registerEvents() {
      google.maps.event.addDomListener(window, 'load', initMap);

      $cache.mapBoxItemCTA.on('click', onBoxClick);

      $cache.zipForm.on('submit', onSubmit);
    }

    /**
     * Unregister events
     */
    function unregisterEvents() {
      $cache.mapBoxItemCTA.off('click', onBoxClick);
      $cache.zipForm.off('submit', onSubmit);
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(options) {
      $cache.main = options.$el;
      initCache();

      registerEvents();
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.MapLocation = MapLocation;

}(jQuery));
